import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { PhoneButtonSwitcher } from '../../components/PhoneButtonSwitcher';
import { CallButton } from '../../components/mobile/Promos/CallButton';
import { Promo } from '../../components/mobile/Promos/Promo';
import { PromoLayout } from '../../components/mobile/Promos/PromoLayout';
import { selectPromotions } from '../../selectors/promotions';
import { selectVillage } from '../../selectors/village';

export function MobilePromosContainer() {
  const promotions = useSelector(selectPromotions);
  const village = useSelector(selectVillage);
  const deviceType = useDeviceType();
  const phoneButton =
    deviceType === 'phone' ? <CallButton /> : <PhoneButtonSwitcher phone={village.builder?.phone} buttonSize="M" />;

  if (!promotions?.length) {
    return null;
  }

  return (
    <PromoLayout>
      {promotions.map(promo => (
        <Promo {...promo} key={promo.id} phoneButton={phoneButton} />
      ))}
    </PromoLayout>
  );
}
